import { render, staticRenderFns } from "./SportShow.vue?vue&type=template&id=6d737a8e&"
import script from "./SportShow.vue?vue&type=script&lang=js&"
export * from "./SportShow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports